import { NgModule } from '@angular/core';
import { Logger } from '@mode/shared/contract-common';
import { createLoggerService } from './logger-service.factory';

@NgModule({
  providers: [{ provide: Logger, useFactory: createLoggerService, deps: [Window] }],
})
export class SharedUtilLoggingModule {}
